import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createMaterial = async (data) => {
    try {
      const response = await api.create(`/materials/add`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const createMaterialList = async (data) => {
    try {
      const response = await api.create(`/materials/add-list`, data);
      console.log('response vehiclesData', response)
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getMateriels = async () => {
    try {
      const response = await api.get(`/materials/all`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const updateMaterial = async ( id, data) => {
      try {
        const response = await api.put(`/materials/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteMaterial = async (id) => {
    try {
        const response = await api.delete(`/materials/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const affectVehicle = async (driverId, vehicleId) => {
    try {
        const response = await api.put(`/vehicles/affect/user/${driverId}/vehicle/${vehicleId}`);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const getVehicleHistory = async (vehicleId) => {
    try {
      const response = await api.get(`/history/vehicles/${vehicleId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getDemandeMateriels = async () => {
    try {
      const response = await api.get(`/material-requests/all`);
      return response;
    } catch (error) {
      throw error;
    }
  };
